'use client'

import { SvgArrowDown } from '../icons';
import s from './selectSpecialization.module.scss';
import { useState } from 'react';

export const SelectSpecialization = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSpecialization, setSelectedSpecialization] = useState('Специализация врача');

  //todo: В рамках этой задачи моковые данные, так как не релизован поиск на бэке
  const specializations = ['Акушер-гинеколог', 'Аллерголог-иммунолог', 'Анестезиолог-реаниматолог', 'Венеролог', 'Вертебролог', 'Гастроэнтеролог'];

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (specialization: string) => {
    setSelectedSpecialization(specialization);
    setIsOpen(false);
  };

  return (
    <div className={s.dropdownContainer}>
      <div
        onClick={toggleDropdown}
        className={`${s.toggleDropdown} ${selectedSpecialization !== 'Специализация врача' ? s.selected : ''}`}
      >
        {selectedSpecialization}
        <div className={isOpen ? s.arrow : s.arrowUp}><SvgArrowDown /></div>
      </div>
      {isOpen && (
        <div className={s.dropdownMenu}>
          {specializations.map((specialization) => (
            <div
              key={specialization}
              onClick={() => handleSelect(specialization)}
              className={s.dropdownMenuItem}
            >
              {specialization}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};